module.exports = __webpack_public_path__ + "img/x.0c9462a7.svg";